// common style for desktop and mobile feature modal
import styled, { css } from 'styled-components'
import { Text as StormText, Link } from '@amzn/storm-ui'

export const customColor = (color = 'squidInk') => css`
  color: ${({ theme }) => theme.palette[color]};
`

export const customBgColor = (color = 'white') => css`
  background-color: ${({ theme }) => theme.palette[color]};
`

export const customFont = (font = 'base') =>
  css`
    font-size: ${({ theme }) => theme.typography.size[font]};
  `

export const customPadding = (top = 'none', right = 'none', bottom = 'none', left = 'none') => css`
  padding: ${({ theme }) => theme.spacing[top]} ${({ theme }) => theme.spacing[right]} ${({ theme }) => theme.spacing[bottom]} ${({ theme }) => theme.spacing[left]};
`

export const customMargin = (top = 'none', right = 'none', bottom = 'none', left = 'none') => css`
  margin: ${({ theme }) => theme.spacing[top]} ${({ theme }) => theme.spacing[right]} ${({ theme }) => theme.spacing[bottom]} ${({ theme }) => theme.spacing[left]};
`

export const customMobilePadding = (top = 'none', right = 'none', bottom = 'none', left = 'none') => css`
  padding: ${({ theme }) => theme.mobile.spacing[top]} ${({ theme }) => theme.mobile.spacing[right]} ${({ theme }) => theme.mobile.spacing[bottom]} ${({ theme }) => theme.mobile.spacing[left]};
`

export const customMobileMargin = (top = 'none', right = 'none', bottom = 'none', left = 'none') => css`
  margin: ${({ theme }) => theme.mobile.spacing[top]} ${({ theme }) => theme.mobile.spacing[right]} ${({ theme }) => theme.mobile.spacing[bottom]} ${({ theme }) => theme.mobile.spacing[left]};
`
export const Text = styled(StormText)<{ variant?: string; font?: number; lineHeight?: number }>`
  color: ${({ variant, theme }) => theme.palette[variant ? variant : 'squidInk']};
  ${(props) =>
    props.font
      ? css`
          font-size: ${props.font}px;
        `
      : null}
  ${(props) =>
    props.lineHeight
      ? css`
          line-height: ${props.lineHeight}px;
        `
      : null}

  &&:not(:last-of-type) {
    ${customMargin('none', 'none', 'small', 'none')}
  }
`

export const IngressLink = styled(Link)`
  font-family: 'Amazon Ember', Helvetica, sans-serif;
  &&& {
    color: rgb(0, 102, 192);
    text-decoration: none;
  }
`

export const NoDataContainer = styled.div`
  padding: 0 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
`

export const NoNewReleaseText = styled(Text)`
  padding-top: ${({ theme }) => theme.mobile.spacing.xxlarge};
`

export const ReleaseNotesText = styled(Text)`
  padding-top: ${({ theme }) => theme.mobile.spacing.medium};
  padding-bottom: ${({ theme }) => theme.mobile.spacing.xxlarge};
`

export const MultilineContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${customMargin('medium', 'none', 'xlarge', 'none')}
`
